import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, TrendingUp, Play } from 'lucide-react';
import { Link } from 'react-router-dom';

interface Oyun {
  id: string;
  name: string;
  imageUrl: string;
  provider: string;
  commentCount: number;
  trend: 'up' | 'down' | 'stable';
}

// Demo veriler - SarLab'da konusulan oyun verisi yok
const demoOyunlar: Oyun[] = [
  { id: '1', name: 'Sweet Bonanza', imageUrl: 'https://via.placeholder.com/100x100/6366f1/ffffff?text=SB', provider: 'Pragmatic', commentCount: 1250, trend: 'up' },
  { id: '2', name: 'Gates of Olympus', imageUrl: 'https://via.placeholder.com/100x100/8b5cf6/ffffff?text=GO', provider: 'Pragmatic', commentCount: 980, trend: 'up' },
  { id: '3', name: 'Crazy Time', imageUrl: 'https://via.placeholder.com/100x100/ec4899/ffffff?text=CT', provider: 'Evolution', commentCount: 870, trend: 'stable' },
  { id: '4', name: 'Lightning Roulette', imageUrl: 'https://via.placeholder.com/100x100/f59e0b/ffffff?text=LR', provider: 'Evolution', commentCount: 650, trend: 'up' },
  { id: '5', name: 'Mega Ball', imageUrl: 'https://via.placeholder.com/100x100/10b981/ffffff?text=MB', provider: 'Evolution', commentCount: 520, trend: 'down' },
];

const KonusulanOyunlar: React.FC = () => {
  const [loading, setLoading] = useState(true);

  // Demo verileri kullan - SarLab'da konusulan oyun verisi yok
  useEffect(() => {
    // Simule loading
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  const displayData = demoOyunlar;

  return (
    <div className="bg-dark-800/50 backdrop-blur-sm rounded-2xl p-6 border border-dark-700 h-full flex flex-col">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 rounded-lg bg-gradient-to-r from-purple-500 to-pink-500 flex items-center justify-center">
            <MessageCircle className="w-5 h-5 text-white" />
          </div>
          <h2 className="text-xl font-bold text-white">En Çok Konuşulan Oyunlar</h2>
        </div>
        <Link to="/slotlar" className="text-primary-400 hover:text-primary-300 text-sm">
          Tümünü Gör →
        </Link>
      </div>

      <div className="space-y-2 flex-1">
        {loading ? (
          <div className="animate-pulse space-y-2">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="h-14 bg-dark-700/50 rounded-lg" />
            ))}
          </div>
        ) : (
          displayData.map((oyun, index) => (
            <motion.div
              key={oyun.id}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
              className="group flex items-center justify-between p-3 bg-dark-700/30 rounded-lg hover:bg-dark-700/50 transition-colors cursor-pointer"
            >
              <div className="flex items-center space-x-3">
                <div className="relative">
                  <img
                    src={oyun.imageUrl}
                    alt={oyun.name}
                    className="w-12 h-12 rounded-lg object-cover"
                  />
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-dark-900/50 rounded-lg">
                    <Play className="w-5 h-5 text-white" />
                  </div>
                </div>
                <div>
                  <p className="text-white font-medium">{oyun.name}</p>
                  <p className="text-gray-400 text-sm">{oyun.provider}</p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <div className="flex items-center space-x-1 text-gray-400">
                  <MessageCircle className="w-4 h-4" />
                  <span className="text-sm">{oyun.commentCount}</span>
                </div>
                <TrendingUp className={`w-4 h-4 ${
                  oyun.trend === 'up' ? 'text-green-400' :
                  oyun.trend === 'down' ? 'text-red-400' : 'text-gray-400'
                }`} />
              </div>
            </motion.div>
          ))
        )}
      </div>
    </div>
  );
};

export default KonusulanOyunlar;
